import { render } from "./CopyIcon.vue?vue&type=template&id=4c21f64f"
const script = {}

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__